import { HgsArticle, SearchEntry } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { splitServiceTitle } from './hgs-helper';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-hgs-service-schedules',
  imports: [CommonModule, TranslocoPipe, RouterLink],
  template: `
    <h2>{{ 'documents.hgs.inspection.title' | transloco }}</h2>

    <ul class="mt-4 flex flex-col gap-2">
      @for (item of listOfOptions(); track item.id) {
        <li class="flex">
          <a
            [routerLink]="item.link.path"
            [queryParams]="item.link.queryParams"
            class="flex-1 rounded-lg border border-gray-300 bg-sky-50 px-4 py-2 hover:bg-sky-100">
            <strong class="block py-1 font-semibold">{{ item.text }}</strong>
            {{ item.interval }}
          </a>
        </li>
      }
    </ul>

    <pre class="mt-4 hidden rounded-lg bg-violet-50">{{ data() | json }}</pre>
  `,
  standalone: true,
})
export class HgsServiceSchedulesComponent {
  data = input<HgsArticle | undefined>();
  router = inject(Router);

  listOfOptions = computed(() => {
    const inspectionOptions = this.data()?.data?.serviceSchedules;
    if (!inspectionOptions) return [];
    return inspectionOptions.map((schedule: SearchEntry) => ({
      id: schedule.id,
      text: splitServiceTitle(schedule.text)?.name,
      interval: splitServiceTitle(schedule.text)?.interval,
      link: this._generateLink(schedule),
    }));
  });

  private _generateLink(schedule: SearchEntry) {
    const basePath = this.router.url.split('?')[0];
    const queryParams = { articleView: true, provider: schedule.provider, ...schedule.parameters };
    return {
      path: basePath,
      queryParams: {
        ...queryParams,
      },
    };
  }
}
